import { useAuthStore } from "~/stores/auth";

export default defineNuxtPlugin(async () => {
  // Run only on client
  if (process.server) return;
  try {
    const auth = useAuthStore();
    if (typeof (auth as any).ensureInitialAdmin === "function") {
      await (auth as any).ensureInitialAdmin();
    }
  } catch (e) {
    // ignore in SSR or if store not available
    // eslint-disable-next-line no-console

  }
});
